import { Linear, Sine, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { Obstacle } from "../../GameObjects/Obstacles/Obstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class PaletasProjectile extends Obstacle {
    private static readonly SPEED: number = -175;
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, -50);

    private _rotateTween: TweenMax | undefined;
    private _throwTween: TweenLite | undefined;

    constructor() {
        super(PaletasProjectile.SPEED, new BoxCollider(-30, 30, -30, 30));
        this._collisionSfx = SFX.IMPACT_PALETA;

        this._image = HLF.PixiUtils.makeSprite("paletas-projectile", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00");
        this.addChild(this._image);

        this._rotateTween = TweenMax.to(this._image, 1.0, {
            rotation: -Math.PI * 2,
            ease: Linear.easeNone,
            repeat: -1,
        });

        this._throwTween = TweenLite.to(this, 1.0, {
            y: HLF.Random.floatBetweenPoint(PaletasProjectile.Y_RANGE),
            ease: Sine.easeOut,
        });
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._rotateTween !== undefined) { this._rotateTween.kill(); }
        if (this._throwTween !== undefined) { this._throwTween.kill(); }
        super.destroy(pOptions);
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        super.onCollision(pIsBalloonInvuln);
        if (pIsBalloonInvuln) {
            if (this._rotateTween !== undefined) { this._rotateTween.kill(); }
            if (this._throwTween !== undefined) { this._throwTween.kill(); }
            this.playDeflectAnim();
        }
    }
}
